import PropTypes from 'prop-types'

import { iso8601PropType } from '../common/iso-8601-prop-type'

/**
 * @typedef {Object} CameraEventUserAccess
 * @property {string} [eventUserAccessId] - Id of the log entry.
 * @property {string} [action]  - action type that was logged, can be one of CREATE, VIEW, RESOLVE, DOWNLOAD.
 * @property {string} [eventId] - The internal ID of the event.
 * @property {string} [time]    - The time when this access happened in ISO8601 UTC format.
 * @property {string} [userId]  - The ID of the user associated with this event access.
 */
export const cameraEventUserAccessPropType = PropTypes.shape({
    action: PropTypes.oneOf(['CREATE', 'VIEW', 'RESOLVE', 'DOWNLOAD']),
    eventId: PropTypes.string,
    eventUserAccessId: PropTypes.string,
    time: iso8601PropType,
    userId: PropTypes.string
})
